module.exports = __webpack_public_path__ + "static/media/ORGDASH-ReviewFeed.52e6d7cf.png";